import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import store from '@/store';
import CONFIG from "@/assets/js/config.js";

export default {
    name: "gradingDetail",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            gradingInfo: {},
            academicYearArr: null,
            gradingArr: null,
            noDataMsg: CONFIG.NO_DATA_EXIST,
            gradeData: {},
            subjectArr: [],
            academicYear: '',
            gradeTotal: 0,
        };
    },

    methods: {
        getAcademicYear() {
            axios.get('getAcademicYear', {
              params: {
                  campus_id: store.state.user.campus_id
              }
          })
                .then(res => {
                let $defaultSelectOption = [{
                    'id': 0,
                    'text': 'Select'
                }];
                this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
                }).catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
                });
        },
        
        async getGradingDetail() {
            try {
                this.isLoading = true;
        
                const response = await axios.get("/grading/gradingDetail/" + this.$route.params.student_id, {
                    params: {
                        campus_id: store.state.user.campus_id,
                        exam_id: this.$route.params.exam_id
                    }
                });
        
                if (response.data[0] != undefined) {
                    this.gradingInfo = response.data[0];
                    this.gradeData = this.gradingInfo.exam_gradings;
                    this.selectedClass = this.gradingInfo.class_id;
                    let gradeTotal = 0;
                    let hasFloat = false;

                    this.gradeData.forEach(gradeData => {
                        let mark = parseFloat(gradeData.mark) || 0;
                        if (!Number.isInteger(mark)) {
                            hasFloat = true;
                        }
                        gradeTotal += mark;
                    });

                    this.gradeTotal = hasFloat ? gradeTotal : Math.round(gradeTotal);
                }
            } catch (error) {
                if (error.response && error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                console.error("Grading Detail API Error", error);
            } finally {
                this.isLoading = false;
            }
        },

        showList() {
            this.$router.push({
                path: "/grading/list"
            });
        },

        async getThisAcademicYear() {
            try {
            const response = await axios.get('period/getThisPeriod')
            if (response) {
                this.academicYear = response.data;
                this.academic_year = this.academicYear.id;
            }
         } catch (error)  {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            }
        },
    },
    
    mounted() {
        this.isLoading = true;
        this.getAcademicYear();
        this.getGradingDetail();
    },
};
